import { BeSegmentedProgressBar, BeStack } from "@beos-css/react/index.ts";

export function SegmentedProgressBarDemo() {
	return (
		<section id="demo-segmented-progress-bar">
			<h3>Multi-segment</h3>
			<p>
				A multi-colour <em>segmented</em> bar — the GitHub "language breakdown" / Primer "multiple segments" idea — as a sibling of the
				determinate bar. Not a real BeOS control (<code>BStatusBar</code> was single-colour); it reuses the same recessed trough and a
				single raised bevel, with flat colour runs split by engraved dividers. Each segment's bevel shades are derived from its own colour
				with CSS <code>color-mix</code>, which reproduces BeOS's <code>shift_color()</code>/<code>tint_color()</code> exactly (lite =
				<code>shift(c, 0.59)</code>, dark = <code>shift(c, 1.407)</code>) — so any caller colour gets the authentic bevel for free. Segments
				take an explicit <code>color</code>, a standardized status <code>tone</code> (<code>done/active/blocked/pending</code>, etc.), or
				neither — unspecified segments auto-assign the curated categorical sequence (<code>--be-cat-N</code>).
			</p>
			<BeStack gap="group" align="start">
				<BeSegmentedProgressBar
					label="Languages"
					trailing="100%"
					legend
					segments={[
						{ value: 45, label: "TypeScript" },
						{ value: 22, label: "C++" },
						{ value: 13, label: "Shell" },
						{ value: 12, label: "CSS" },
						{ value: 8, label: "Other" },
					]}
				/>
				<BeSegmentedProgressBar
					label="Epic progress"
					trailing="18 / 24"
					legend
					segments={[
						{ value: 12, tone: "done", label: "Done" },
						{ value: 4, tone: "active", label: "Active" },
						{ value: 2, tone: "blocked", label: "Blocked" },
						{ value: 6, tone: "pending", label: "Pending" },
					]}
				/>
				<BeSegmentedProgressBar
					label="Phases"
					trailing="70%"
					max={100}
					segments={[
						{ value: 40, color: "#3aa655", label: "Build" },
						{ value: 30, color: "#3178c6", label: "Test" },
					]}
				/>
			</BeStack>
		</section>
	);
}
